import { STATE_LOGIN, STATE_SIGNUP } from 'components/AuthForm';
import GAListener from 'components/GAListener';
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
import PageSpinner from 'components/PageSpinner';
import AuthPage from 'pages/AuthPage';
import React from 'react';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './styles/reduction.scss';
import jwt from 'jsonwebtoken'
import PrivateRoutes from './PrivateRoutes';




const CardPage = React.lazy(() => import('pages/CardPage'));
const ChartPage = React.lazy(() => import('pages/ChartPage'));
const Userpage = React.lazy(() => import('pages/User'));
const WidgetPage = React.lazy(() => import('pages/WidgetPage'));
const InspectionPage = React.lazy(() => import('pages/Inspection'))
const InspectionEdit = React.lazy(() => import('pages/InspectionEdit') )
const Dashboard = React.lazy(() => import('pages/Dashboard') )
const Factorordersheet = React.lazy(() => import('pages/Factorordersheet') )
const InspectionReport = React.lazy(() => import('pages/InspectionReport') )
const InspectionReportsummary = React.lazy(() => import('pages/InspectionReportSummary') )
const Defactdescription = React.lazy(() => import('pages/Defactdescription'))
const Viewdocs = React.lazy(() => import('pages/Viewdocs'))
const logout = React.lazy(() => import('pages/Logout'))
const Home = React.lazy(() => import('pages/Home'))
const Approvalview = React.lazy(()=> import('pages/Approvalview'))
const Changepassword = React.lazy(()=> import('pages/Changepassword'))
const purchaseordertracking = React.lazy(()=> import('pages/Purchaseordertracking'))
const Productpage = React.lazy(()=> import('pages/Productpage'))
const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};




class App extends React.Component {
  render() {
    
    return (
      <BrowserRouter basename={getBasename()}>

        
      
<Switch>

          
<LayoutRoute
              exact
              path="/"
              layout={EmptyLayout}
              component={props => (
                <AuthPage {...props} authState={STATE_LOGIN} />
              )}
            />
      

     <Route  component={ <PrivateRoutes />}>
   
        
          
        
         

          
        
            
          
            <MainLayout breakpoint={this.props.breakpoint}>
              
              <React.Suspense fallback={<PageSpinner />}>
                {/* <Route exact path="/" component={DashboardPage} /> */}
                <Route   exact path="/login" component={AuthPage} />
                <Route extends path="/Dashboard" component={Dashboard} />
                <Route exact path="/Approval" component={CardPage} />
                <Route exact path="/viewpo" component={WidgetPage} />
                
             <Route exact path="/user" component={Userpage}  /> 
             <Route exact path="/Factoryordersheet" component={Factorordersheet}  /> 
             <Route exact path="/logout" component={logout}  /> 
             <Route exact path="/Home" component={Home}  /> 
             <Route exact path="/changepassword" component={Changepassword}  /> 

                <Route exact path="/inspection" component={InspectionPage}  />
                <Route exact path="/Purchaseorder" component={ChartPage} />
                <Route exact path="/Purchaseorder/:id" component={ChartPage} />
                <Route exact path="/Product" component={Productpage} />
                <Route exact path="/Product/:id" component={Productpage} />

                <Route exact path="/outstanding" component={InspectionEdit} />
                <Route exact path="/inspection/:id" component={InspectionPage}  />
                <Route exact path="/inspectionsummary" component={InspectionReport}  />
                <Route exact path="/inspectionReport" component={InspectionReportsummary}  />
                <Route exact path="/viewdocs" component={Viewdocs} />
                <Route exact path="/approvalview/:id" component={Approvalview} />
                <Route exact path="/changepassowrd" component={Changepassword} />
                <Route exact path="/PurchaseordertrackingReport" component={purchaseordertracking} />

              </React.Suspense>
            </MainLayout>
          
         
         
       </Route>
     </Switch>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
